import { render, staticRenderFns } from "./UniCampusCourses.vue?vue&type=template&id=b07c0fc0&"
import script from "./UniCampusCourses.vue?vue&type=script&lang=js&"
export * from "./UniCampusCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports